import {Base} from '../../common/model/base.model';
import {GeoComune} from '../geocomune/geo-comune.model';
import {GeoCap} from '../geocap/geo-cap.model';

export class GeoIndirizzo extends Base {

  constructor(protected id: number,
              public via: string,
              public civico: string,
              public localita: string,
              public comune: GeoComune,
              public cap: GeoCap
  ) {
    super(id);
  }

  public getLabel() {
    return this.via + ' ' + this.civico + ' - ' + this.comune.getLabel();
  }

}
